// This file was automatically generated from appshared.dialog.viewEducationalHandouts.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.viewEducationalHandouts');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.viewEducationalHandouts.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="padt20"><div class="tabbed-nav el8Tab"></div></div><div class="medline-section"></div><div class="elation-section"><div class="el8DialogContainer"><div class="el8FieldSectionOverflow ebs-row"><div class="ebs-col-sm-6 ebs-col-sm-offset-6"><form class="search-handouts-form"><div class="apptSearch ebs-from-group ebs-has-feedback"><div class="apptSearchWrap"><input class="w100 ebs-form-control" type="text" name="search" /><a href="#" class="clear-search-trigger removeSearch"></a><button class="el8button dialog-buttons search-trigger search"></button></div></div></form></div></div><h4 class="el8SectionHeaderNoCollapse">Patient Educational Handouts</h4><div id="educational-handouts-list"></div></div><div id="upload-handout-section" class="mt20"><div class="padl20"><button type="button" class="el8button show-upload-handout-trigger el8PrimaryButton ebs-btn ebs-btn-primary">Upload File</button></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.viewEducationalHandouts.uploadHandoutInProgress = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="upload-handout-inprogress" class="dataLoading"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.viewEducationalHandouts.uploadHandoutError = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldMediumLabelPadding el8Wrap"><div class="el8NotificationCaution"><p class="el8AttentionText">There was an error uploading the file. Please try again.</p></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.viewEducationalHandouts.fileInput = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<input type="file" class="w100" name="handoutFile" />');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.viewEducationalHandouts.uploadHandoutForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="upload-handout-form-container" class="cardColumnTB cardColumnBg"><div class="padh20"><p class="el8Bold el8AppColor padt10">Upload Patient Handout</p><form id="upload-handout-form" class="el8UploadForm ebs-form-horizontal padt10"><div class="el8FieldSection ebs-form-group"><div id="upload-handout-form-msg" class="fr el8AlignRight el8Bold el8StandardFontSize"></div><div class="el8SettingsGenericItem"><label class="el8label el8FieldMedium el8FieldRequired ebs-control-label ebs-col-sm-2"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>File:</span></label><div class="el8FieldMediumLabelPadding el8Wrap ebs-col-sm-10">');
  el8.template.appshared.dialog.viewEducationalHandouts.fileInput(null, output);
  output.append('</div></div></div><div class="el8SettingsGenericItem el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium el8FieldRequired ebs-control-label ebs-col-sm-2"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Name:</span></label><div class="el8FieldMediumLabelPadding el8TextareaWrap ebs-col-sm-10"><input type="text" class="w100 ebs-form-control" name="handoutName" /></div></div><div class="el8SettingsGenericItem el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2">Tags:</label><div class="el8FieldMediumLabelPadding el8TextareaWrap ebs-col-sm-10"><input type="text" class="w100 ebs-form-control" name="tags" /></div><p class="el8FieldMediumLabelPadding el8AppColor ebs-col-sm-10 ebs-col-sm-offset-2 ebs-help-block">Note: Add multiple tags by adding a comma.</p></div><div class="el8FieldMediumLabelPadding ebs-col-sm-10 ebs-col-sm-offset-2"><div class="ebs-row"><div id="upload-handout-buttons"></div></div></div></form></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.viewEducationalHandouts.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.handouts.length) {
    output.append('<ol class="padl20 padt10 ebs-list-unstyled">');
    var hList8944 = opt_data.handouts;
    var hListLen8944 = hList8944.length;
    for (var hIndex8944 = 0; hIndex8944 < hListLen8944; hIndex8944++) {
      var hData8944 = hList8944[hIndex8944];
      output.append('<li data-id="', soy.$$escapeHtml(hData8944.id), '" class="handout-item el8ItemHover el8BulletText mb5">', (! hData8944.isShared) ? '<div class="el8RemoveButtonItemPosition"><a class="remove-trigger el8RemoveItemButton"></a></div>' : '', '<a class="', (opt_data.selectable) ? 'select-trigger' : '', '" data-url="', soy.$$escapeHtml(hData8944.url), '">', soy.$$escapeHtml(hData8944.name), '</a>');
      if (hData8944.tags.length) {
        output.append(' ');
        var tList8963 = hData8944.tags;
        var tListLen8963 = tList8963.length;
        for (var tIndex8963 = 0; tIndex8963 < tListLen8963; tIndex8963++) {
          var tData8963 = tList8963[tIndex8963];
          output.append('<span class="el8TagItem mr5">', soy.$$escapeHtml(tData8963), '</span>');
        }
      }
      output.append('</li>');
    }
    output.append('</ol>');
  } else {
    output.append('<p class="el8SectionEmpty">No handouts uploaded</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.viewEducationalHandouts.medlinePlusSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div class="el8AlignRight padv10"><a href="https://www.nlm.nih.gov/medlineplus" class="el8Link" target="_blank" rel="noopener">Search MedlinePlus for additional patient resources</a></div><h4 class="el8SectionHeaderNoCollapse">Resources Based on Active Problems</h4>');
  if (opt_data.problems.length) {
    output.append('<ul class="el8StandardList">');
    var problemList8978 = opt_data.problems;
    var problemListLen8978 = problemList8978.length;
    for (var problemIndex8978 = 0; problemIndex8978 < problemListLen8978; problemIndex8978++) {
      var problemData8978 = problemList8978[problemIndex8978];
      output.append('<li class="padv5"><a class="medline-select-trigger" data-url="', soy.$$escapeHtml(problemData8978.url), '">', soy.$$escapeHtml(problemData8978.name), '</a> <span class="el8Code">[', soy.$$escapeHtml(problemData8978.code), ']</span></li>');
    }
    output.append('</ul>');
  } else {
    output.append('<p class="el8SectionEmpty">No resources found</p>');
  }
  output.append('<h4 class="el8SectionHeaderNoCollapse mt10">Resources Based on Medications Taken</h4>');
  if (opt_data.meds.length) {
    output.append('<ul class="el8StandardList">');
    var medList8994 = opt_data.meds;
    var medListLen8994 = medList8994.length;
    for (var medIndex8994 = 0; medIndex8994 < medListLen8994; medIndex8994++) {
      var medData8994 = medList8994[medIndex8994];
      output.append('<li class="padv5"><a class="medline-select-trigger" data-url="', soy.$$escapeHtml(medData8994.url), '">', soy.$$escapeHtml(medData8994.name), '</a></li>');
    }
    output.append('</ul>');
  } else {
    output.append('<p class="el8SectionEmpty">No resources found</p>');
  }
  output.append('<h4 class="el8SectionHeaderNoCollapse mt10">Resources Based on Recent Lab Results</h4>');
  if (opt_data.labs.length) {
    output.append('<ul class="el8StandardList">');
    var labList9008 = opt_data.labs;
    var labListLen9008 = labList9008.length;
    for (var labIndex9008 = 0; labIndex9008 < labListLen9008; labIndex9008++) {
      var labData9008 = labList9008[labIndex9008];
      output.append('<li class="padv5"><a class="medline-select-trigger" data-url="', soy.$$escapeHtml(labData9008.url), '">', soy.$$escapeHtml(labData9008.name), '</a></li>');
    }
    output.append('</ul>');
  } else {
    output.append('<p class="el8SectionEmpty">No resources found</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
